import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input/input';


//Style
require('./searchbox.scss');

export default class SearchBox extends React.PureComponent {
  constructor() {
    super();
  }

  render() {
    return (
      <Input
        onChange={this.props.onChange}
        value={this.props.value}
        classIcon="search"
        type='text'
        placeholder={this.props.placeholder || 'Search...'} />
    );
  }
}

SearchBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
};

